export enum StoreDataStatus {
    FetchingError='Error fetching data',
    NoData='No data',
}

export function isInstanceOfStoreDataStatus(value: any): value is StoreDataStatus {
    return (<any>Object).values(StoreDataStatus).includes(value);
}
